import { useEffect, useState } from 'react';
import { message, Col, Row, Divider, Space, Typography, Drawer, Tabs, Card, Empty, List } from 'antd';
import { useTranslation } from 'react-i18next';
import { drawerWidth750, logTypesNames, orderUploadStatus } from '../../../utils/constants';
import BulkImportServices from '../../../services/bulkImportServices';
import Loader from '../../../components/common/Loader';
import { useLoader } from '../../../context/loaderContext';
import { orderUploadStatusComp } from '../../../utils/functions';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
const { Text } = Typography;

const ImportLogsDetails = ({ visibility, onClose, selectedLog }: { visibility: boolean, onClose: () => void, selectedLog: any | null }) => {
    const { t } = useTranslation();
    const { loading, setLoading } = useLoader();
    const [logsDetails, setLogsDetails] = useState<any>(null);
    const [logsErrors, setLogsErrors] = useState<any[]>([]);

    useEffect(() => {
        if (!selectedLog && !selectedLog.logID) return;

        if (selectedLog.logTypeName !== logTypesNames.localFiles) {
            getLogDetails(selectedLog.logID);
        }

    }, [selectedLog]);

    const getLogDetails = async (logId: string) => {
        setLoading(true);
        try {
            const respData = await BulkImportServices.getLogDetails(logId);
            if (respData.success) {
                const res = respData.responseObject.value.executionLogsInfo[0];
                setLogsDetails(res.executionLogsHeader);
                setLogsErrors(res.executionLogsDetails);
            }
            else {
                message.error(t('messages.errorAccured'));
            }
        } catch (error) {
            message.error(t('messages.errorAccured'));
        } finally {
            setLoading(false);
        }
    };

    const LogDetailsTab = ({ logDetails }: { logDetails: any }) => {
        return (
            <>
                {logDetails && (
                    <Row gutter={[16, 16]}>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} >
                            <Card>
                                <Space direction='vertical' style={{ width: "100%" }}>
                                    <Space direction='horizontal'>
                                        <Text strong>{t('logs.status')}: </Text>
                                        <Text>{orderUploadStatusComp(logDetails.status, t)}</Text>
                                    </Space>

                                    {(logDetails.status === orderUploadStatus.failed && logDetails.message) && (
                                        <Space direction='horizontal'>
                                            <Text type='danger' strong>{t('logs.message')}: </Text>
                                            <Text type='danger'>{logDetails.message}</Text>
                                        </Space>
                                    )}

                                    {(logDetails.status === orderUploadStatus.success && logDetails.message) && (
                                        <Space direction='horizontal'>
                                            <Text type='success' strong>{t('logs.message')}: </Text>
                                            <Text type='success'>{logDetails.message}</Text>
                                        </Space>
                                    )}
                                    <Divider style={{ margin: "4px 0" }} />

                                    <Space direction='horizontal'>
                                        <Text strong>{t('logs.fileName')}: </Text>
                                        <Text>{logDetails.fileName}</Text>
                                    </Space>
                                    <Space direction='horizontal'>
                                        <Text strong>{t('logs.username')}: </Text>
                                        <Text>{logDetails.userName}</Text>
                                    </Space>
                                </Space>
                            </Card>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} >
                            <Card>
                                <Space direction='vertical' style={{ width: "100%" }}>
                                    <Space direction='horizontal'>
                                        <Text strong>{t('logs.startTime')}: </Text>
                                        <Text>{logDetails.startTime ? dayjs.utc(logDetails.startTime).tz(dayjs.tz.guess()).format('DD/MM/YYYY - HH:mm') : ""}</Text>
                                    </Space>
                                    <Space direction='horizontal'>
                                        <Text strong>{t('logs.endTime')}: </Text>
                                        {/* <Text>{logDetails.endTime ? dayjs(logDetails.endTime).format('DD/MM/YYYY - HH:mm') : ""}</Text> */}
                                        <Text>{logDetails.endTime ? dayjs.utc(logDetails.endTime).tz(dayjs.tz.guess()).format('DD/MM/YYYY - HH:mm') : ""}</Text>
                                    </Space>
                                    <Space direction='horizontal'>
                                        <Text strong>{t('logs.rowsProcessed')}: </Text>
                                        <Text>{logDetails.rowsProcessed}</Text>
                                    </Space>
                                    <Space direction='horizontal'>
                                        <Text strong>{t('logs.rowsFailed')}: </Text>
                                        <Text>{logDetails.rowsFailed}</Text>
                                    </Space>
                                    <Space direction='horizontal'>
                                        <Text strong>{t('logs.validationsFailed')}: </Text>
                                        <Text>{logDetails.validationsFailed}</Text>
                                    </Space>
                                </Space>
                            </Card>

                        </Col>
                    </Row>
                )}
            </>
        )
    }

    const LogErrorsTab = ({ logDetails, logErrors }: { logDetails: any, logErrors: any }) => {
        if (logsErrors && logsErrors.length < 1) return (<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />)

        return (
            <>
                {/* {(logDetails && logDetails.errorMessage) && (
                    <Card className='mb10'>
                        <Space direction='vertical' style={{ width: "100%" }}>
                            <Space direction='horizontal'>
                                <Text strong>{t('logs.errorTaskName')}: </Text>
                                <Text>{logDetails.errorTaskName}</Text>
                            </Space>
                            <Divider style={{ margin: "4px 0" }} />
                            <Space direction='vertical' style={{ rowGap: 1 }}>
                                <Text strong type='danger'>{t('logs.errorMessage')}: </Text>
                                <Text type='danger'>{logDetails.errorMessage}</Text>
                            </Space>
                        </Space>
                    </Card>
                )} */}

                {(logErrors && logErrors.length > 0) && (
                    <Card>
                        <List
                            itemLayout="horizontal"
                            dataSource={logErrors}
                            renderItem={(item: any) => (
                                <List.Item>
                                    <List.Item.Meta
                                        title={(<>
                                            <Text strong>{t('order.orderNumber')}: </Text>
                                            <Text>{item.orderNumber}</Text>
                                            <Divider type="vertical" style={{ background: "#827e7e" }} />
                                            <Text strong>{t('logs.itemNumber')}: </Text>
                                            <Text>{item.itemNumber}</Text>
                                            <Divider type="vertical" style={{ background: "#827e7e" }} />
                                            <Text strong>{t('logs.excelRowNumber')}: </Text>
                                            <Text>{item.excelRowNumber}</Text>
                                        </>)}
                                        description={(<><Text strong type='danger'>{t('general.error')}: </Text> <Text type='danger'>{item.errorMessage}</Text></>)}
                                    />
                                </List.Item>
                            )}
                        />
                    </Card>
                )}
            </>
        )
    }

    const LocalFileLogDetails = ({ selectedLog }: { selectedLog: any }) => {
        return (
            <Row gutter={[16, 16]}>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} >
                    <Card>
                        <Space direction='vertical' style={{ width: "100%" }}>
                            <Space direction='horizontal'>
                                <Text strong>{t('logs.status')}: </Text>
                                <Text>{orderUploadStatusComp(selectedLog?.status, t)}</Text>
                            </Space>

                            {(selectedLog?.status === orderUploadStatus.failed && selectedLog?.errorMessage) && (
                                <Space direction='horizontal'>
                                    <Text type='danger' strong>{t('logs.message')}: </Text>
                                    <Text type='danger'>{selectedLog?.errorMessage}</Text>
                                </Space>
                            )}

                            {(selectedLog?.status === orderUploadStatus.success) && (
                                <Space direction='horizontal'>
                                    <Text type='success' strong>{t('logs.message')}: </Text>
                                </Space>
                            )}
                            <Divider style={{ margin: "4px 0" }} />

                            <Space direction='horizontal'>
                                <Text strong>{t('logs.fileName')}: </Text>
                                <Text>{selectedLog?.fileName}</Text>
                            </Space>
                            <Space direction='horizontal'>
                                <Text strong>{t('logs.username')}: </Text>
                                <Text>{selectedLog?.userName}</Text>
                            </Space>
                        </Space>
                    </Card>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} >
                    <Card>
                        <Space direction='vertical' style={{ width: "100%" }}>
                            <Space direction='horizontal'>
                                <Text strong>{t('logs.startTime')}: </Text>
                                <Text>{selectedLog?.startTime ? dayjs.utc(selectedLog?.startTime).tz(dayjs.tz.guess()).format('DD/MM/YYYY - HH:mm') : ""}</Text>
                            </Space>
                            <Space direction='horizontal'>
                                <Text strong>{t('logs.endTime')}: </Text>
                                {/* <Text>{logDetails.endTime ? dayjs(logDetails.endTime).format('DD/MM/YYYY - HH:mm') : ""}</Text> */}
                                <Text>{selectedLog?.endTime ? dayjs.utc(selectedLog?.endTime).tz(dayjs.tz.guess()).format('DD/MM/YYYY - HH:mm') : ""}</Text>
                            </Space>
                            <Space direction='horizontal'>
                                <Text strong>{t('logs.rowsProcessed')}: </Text>
                                <Text>{selectedLog?.rowsProcessed}</Text>
                            </Space>
                            <Space direction='horizontal'>
                                <Text strong>{t('logs.rowsFailed')}: </Text>
                                <Text>{selectedLog?.rowsFailed}</Text>
                            </Space>
                            <Space direction='horizontal'>
                                <Text strong>{t('logs.validationsFailed')}: </Text>
                                <Text>{selectedLog?.validationsFailed}</Text>
                            </Space>
                        </Space>
                    </Card>

                </Col>
            </Row>
        )
    }

    const onCloseDetails = () => {
        setLogsDetails(null);
        onClose();
    }

    // const items = [
    //     {
    //         key: '1',
    //         label: t('logs.details'),
    //         children: <LogDetailsTab logDetails={logsDetails} />,
    //     },
    //     {
    //         key: '2',
    //         label: t('logs.errors'),
    //         children: <LogErrorsTab logErrors={logsErrors} logDetails={logsDetails} />,
    //     }
    // ];


    const tabs = () => {
        if (selectedLog.logTypeName === logTypesNames.localFiles) {
            return (
                [
                    {
                        key: '1',
                        label: t('logs.details'),
                        children: <LocalFileLogDetails selectedLog={selectedLog} />,
                    }
                ]
            )
        }
        else {
            return (
                [
                    {
                        key: '1',
                        label: t('logs.details'),
                        children: <LogDetailsTab logDetails={logsDetails} />,
                    },
                    {
                        key: '2',
                        label: t('logs.errors'),
                        children: <LogErrorsTab logErrors={logsErrors} logDetails={logsDetails} />,
                    }

                ]
            )
        }
    }

    return (
        <Drawer
            title={t('logs.logDetails')}
            width={drawerWidth750}
            onClose={onCloseDetails}
            destroyOnClose={true}
            open={visibility}
            className='logDetails'
        >
            {loading && (<Loader />)}
            {(!loading) && (
                <Tabs defaultActiveKey="1" items={tabs()} />
            )}
        </Drawer>
    );
}
export default ImportLogsDetails;